module.exports = __webpack_public_path__ + "img/21.eedc6da2.png";